import axios from "axios";

export const TOKEN_KEY = "fv_token";
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errorMessage(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const field = (x) => (x?.loc || []).filter((p) => p !== "body" && p !== "query").map((p) => String(p).replace(/_/g, " ")).join(".");
    return d.map((x) => (x?.msg ? `${field(x) ? `${field(x)[0].toUpperCase()}${field(x).slice(1)}: ` : ""}${x.msg.replace(/^Field required$/, "is required").replace(/^Input should be/, "should be")}` : JSON.stringify(x))).join(" · ");
  }
  return d?.msg || String(d);
}

export const ROLE_LABELS = {
  super_admin: "Super-Admin",
  admin: "Admin",
  fleet_manager: "Fleet Manager",
  garage_supervisor: "Garage Supervisor",
  operator: "Fleet Team",
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s.length === 10 ? `${s}T00:00:00` : s);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtKm = (n) => (n == null ? "—" : `${Math.round(n).toLocaleString("en-IN")} km`);
export const titleCase = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
